import { useTranslation } from 'react-i18next';

type Props = {
  data: number;
};

export const PlanData = ({ data }: Props) => {
  const { t } = useTranslation(['ecommerce']);

  return (
    <>
      {data !== -1 ? data : t('landing.plan.unlimited', 'Unlimited')}
      {data !== -1 ? 'GB ' : null}
    </>
  );
};
